import React from "react";
import { LogoProps } from "./Logo.d";

const Logo: React.FC<LogoProps> = ({ withText, color }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 808.35 199.02"
        fill={color}
      >
        <g>
          <path
            fill="#1a67b2"
            d="M0 147.49V51.52h55.65v7.35H7.97v36.58h45.17v7.19H7.97v44.86H0Zm113.17 1.41c-24.38 0-42.36-20.01-42.36-49.39s17.98-49.39 42.36-49.39 42.52 20.01 42.52 49.39-17.98 49.39-42.52 49.39Zm0-91.29c-20.32 0-34.23 17.19-34.23 41.89s13.91 41.89 34.23 41.89 34.39-17.19 34.39-41.89-13.91-41.89-34.39-41.89Zm71.9 47.52v42.36h-7.97V51.52h33.92c18.76 0 30.17 9.38 30.17 26.88 0 15.63-9.22 24.54-24.38 26.42l28.92 42.67h-9.22l-28.45-42.36h-22.98Zm0-7.03h25.64c14.69 0 22.67-7.35 22.67-19.69s-7.97-19.69-22.67-19.69h-25.64v39.39Zm140.52-46.58v7.35h-51.74v35.48h46.89v7.35h-46.89v38.45h51.74v7.35h-59.55V51.52h59.55Z"
          />
          <path d="M349.66 124.05c3.91 11.57 14.07 17.66 27.2 17.66s23.92-7.03 23.92-19.23c0-8.44-4.38-14.38-16.57-17.82l-18.29-5.16c-13.44-3.75-22.04-9.85-22.04-23.45 0-16.26 13.76-25.95 30.32-25.95 18.76 0 30.01 9.85 33.76 24.07h-7.97c-3.6-10.16-11.88-16.88-25.79-16.88-12.5 0-22.67 6.57-22.67 18.29 0 10.16 6.57 13.76 18.29 17.04l16.1 4.69c15.79 4.38 22.67 12.19 22.67 24.85 0 16.88-13.76 26.73-31.73 26.73s-31.73-8.91-35.48-24.85h8.28Zm88.78 23.44h-7.97V51.52h7.97v95.97Zm20.32-95.97h78.16v7.35h-35.17v88.63h-7.97V58.87h-35.01v-7.35Zm158.03 0v7.35h-51.74v35.48h46.89v7.35h-46.89v38.45h51.74v7.35h-59.55V51.52h59.55Z" />
        </g>
        {withText && (
          <g>
            <ellipse
              fill="#d2d3d4"
              cx="736.96"
              cy="177.92"
              rx="71.39"
              ry="21.09"
            />
            <ellipse
              fill="#bdbec0"
              cx="736.75"
              cy="176.3"
              rx="46.52"
              ry="13.75"
            />
            <path
              fill="#1a67b2"
              d="M788.34 29.78C777.74 11.41 757.97 0 736.73 0c-10.4 0-20.68 2.77-29.73 8-13.77 7.95-23.63 20.79-27.75 36.15-4.12 15.36-2 31.41 5.95 45.18l49.53 85.8c.42.73 1.2 1.18 2.04 1.18s1.62-.45 2.04-1.18l49.53-85.79c10.59-18.38 10.58-41.2-.02-59.56Zm-51.56 56c-13.62 0-24.71-11.08-24.71-24.71s11.08-24.71 24.71-24.71 24.71 11.08 24.71 24.71-11.08 24.71-24.71 24.71Z"
            />
          </g>
        )}
      </svg>
    </>
  );
};
export default Logo;
